import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

import { useFeatureFlags } from '@/components/providers/FeatureFlagsProvider';
import { preLoadDefaultProject } from '@/lib/queries/project';

export const Route = createFileRoute('/_root/rca-demo')({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({ id: 'global.breadcrumb.incidents' }),
  }),
  loader: async ({ context }) => {
    const project = await preLoadDefaultProject({ context });

    // Demo version - skip Slack check and PagerDuty tokens for demo
    return { project, tokens: [] };
  },
});

function RouteComponent() {
  const { FeatureRCADemo } = useFeatureFlags();

  // Check for demo feature flag instead of PagerDuty
  if (FeatureRCADemo !== true) {
    return <Navigate to="/catalog" />;
  }

  return <Outlet />;
}
